export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betnest-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betnest-themeWrapLive" */'./LiveThemeImporter'),
  },
};
